import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-228" data-mp="3hfcvu3gvkgm8">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#F5B301] text-[#F5B301]" aria-hidden="true" data-id="element-229" data-mp="3r78ylrtwouws" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-cream px-5 py-16 sm:py-20" data-id="element-230" data-mp="3ai8gm1gim7">
      <div className="mx-auto max-w-5xl" data-id="element-231" data-mp="421eymmldy8s">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-232" data-mp="44w3ap8q837h">
          What other orthodontic professionals are saying
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-233" data-mp="e0gzg6r4699b">
          <Stars data-id="element-234" data-mp="2au2cu2wcmx1p" />
          <span className="font-bold text-ink" data-id="element-235" data-mp="2aukddbq1nxff">4.9/5</span>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-236" data-mp="2frk9oux3dltc">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_20px_50px_-30px_rgba(38,16,64,0.35)]" data-id="element-237" data-mp="1slkppakd54gx">
              <Stars data-id="element-238" data-mp="1nshruq8jz8ux" />
              <blockquote className="mt-4 text-[16px] leading-relaxed text-ink" data-id="element-239" data-mp="1iupsjb5kwkgp">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-240" data-mp="1et4ma8njv4fh">
                <img src={t.image} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-brand-200" loading="lazy" data-id="element-241" data-mp="1er1lctkuzqvz" />
                <div data-id="element-242" data-mp="26jsjj9m3rpnv">
                  <p className="font-bold text-ink" data-id="element-243" data-mp="26ldg14rz9iod">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-244" data-mp="22igq0t03ykae">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-245" data-mp="1xj47gkg9rzdm">
          <CtaButton label="I want to think through cases with a system" data-id="element-246" data-mp="r3jyncggbizv" />
        </div>
      </div>
    </section>;
}